import { computed, ref } from 'vue';
import { defineStore } from 'pinia';

const useModalStore = defineStore('modal', () => {
  const isShow = ref(false);
  const modalName = ref('');
  const modalData = ref(null);

  function openModal(component, data) {
    isShow.value = true;
    modalName.value = component;
    modalData.value = data;
    document.body.classList.add('modal-open');
  }

  function closeModal() {
    isShow.value = false;

    setTimeout(() => {
      modalName.value = '';
      modalData.value = null;
      document.body.classList.remove('modal-open');
    }, 500);
  }

  return {
    modalData,
    modalName,
    isShow,

    openModal,
    closeModal,
  };
});

export default useModalStore;
